/**
 * class for the entries in the components array of a template
 */
export interface ComponentDefinition {
    componentName?: string;
    type?: string;
    name?: string;
    label?: string;
    mandatory?: boolean;
    defaultValue?: string;
    enabled?: boolean;
    fullWidth?: boolean;
    readOnly?: boolean;
    disableSave?: boolean;
    disableDirty?: boolean;
    visible?: boolean;
    skipRendering?: boolean;
    layout?: string;
}
